var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel" }, [
    _c("div", { staticClass: "panel-heading" }, [
      _c("h4", { staticClass: "panel-title" }, [_vm._v("Chi phí ký gửi")]),
      _c("h4", { staticClass: "text-danger rate panel-title" }, [
        _vm._v(
          "Tỉ giá " +
            _vm._s(_vm._f("formatNumber")(_vm.deposit.curentCNYVN, "0,0"))
        )
      ])
    ]),
    _c("div", { staticClass: "panel-body" }, [
      _c("div", { staticClass: "fee-box" }, [
        _c("div", { staticClass: "fee-label" }, [
          _vm._v("\n                Phí ship nội địa TQ\n            ")
        ]),
        _c("div", { staticClass: "fee-val" }, [
          _c("span", { staticClass: "text-primary" }, [
            _vm._v(
              _vm._s(_vm._f("formatNumber")(_vm.deposit.feeShipVND, "0,0"))
            )
          ]),
          _vm._v("\n                ("),
          _c("span", { staticClass: "text-danger" }, [
            _vm._v(
              "¥" +
                _vm._s(
                  _vm._f("formatNumber")(_vm.deposit.feeShipCN, "0,0.[000]")
                )
            )
          ]),
          _vm._v(")\n            ")
        ])
      ]),
      _vm.deposit.fragileGoodCNY > 0
        ? _c("div", { staticClass: "fee-box" }, [
            _c("div", { staticClass: "fee-label" }, [
              _vm._v("\n                Phí đóng bảo hiểm\n            ")
            ]),
            _c("div", { staticClass: "fee-val" }, [
              _c("span", { staticClass: "text-primary" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("formatNumber")(_vm.deposit.fragileGoodVND, "0,0")
                  )
                )
              ]),
              _vm._v("\n                ("),
              _c("span", { staticClass: "text-danger" }, [
                _vm._v(
                  "¥" +
                    _vm._s(
                      _vm._f("formatNumber")(
                        _vm.deposit.fragileGoodCNY,
                        "0,0.[000]"
                      )
                    )
                )
              ]),
              _vm._v(")\n            ")
            ])
          ])
        : _vm._e(),
      _c("div", { staticClass: "fee-box collapse" }, [
        _c("div", { staticClass: "fee-label" }, [
          _vm._v("\n                Phí cân nặng\n            ")
        ]),
        _c("div", { staticClass: "fee-val" }, [
          _c("span", { staticClass: "text-primary" }, [
            _vm._v(_vm._s(_vm._f("formatNumber")(_vm.deposit.feeWeight, "0,0")))
          ])
        ])
      ]),
      _c("div", { staticClass: "fee-box" }, [
        _c("div", { staticClass: "fee-label" }, [
          _vm._v("\n                Tổng cộng\n            ")
        ]),
        _c("div", { staticClass: "fee-val" }, [
          _c("span", { staticClass: "text-primary" }, [
            _vm._v(
              _vm._s(_vm._f("formatNumber")(_vm.deposit.totalPriceVND, "0,0"))
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "fee-box" }, [
        _c("div", { staticClass: "fee-label" }, [
          _vm._v("\n                Đã thanh toán\n            ")
        ]),
        _c("div", { staticClass: "fee-val" }, [
          _c("span", {
            staticClass: "text-primary",
            domProps: { innerHTML: _vm._s(_vm.payment) }
          })
        ])
      ]),
      _c("div", { staticClass: "fee-box" }, [
        _c("div", { staticClass: "fee-label text-danger" }, [
          _vm._v("\n                Cần thanh toán\n            ")
        ]),
        _c("div", { staticClass: "fee-val" }, [
          _c("span", { staticClass: "text-danger" }, [
            _vm._v(
              _vm._s(
                _vm._f("formatNumber")(
                  _vm.deposit.totalPriceVND - _vm.deposit.payment,
                  "0,0"
                )
              )
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }